import MarketingLayout from "@/components/MarketingLayout";
import ToolPageNew from "@/pages/newsite/ToolPageNew";

export default function GoogleAdsSearchPage() {
  return (
    <MarketingLayout>
      <ToolPageNew />
    </MarketingLayout>
  );
}
